import { EAddressField } from "@rentiohq/shared-frontend/dist/utils/address.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { getMappedLanguages } from "@rentiohq/shared-frontend/dist/utils/location/location.utils";
import { getAddressComponentFields } from "@rentiohq/web-shared-next/dist/utils/address";
import {
  ERentioFormField,
  IFormikProps,
  IFormikValues,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField } from "./schema.profilePersonal.types";

export const uiSchema = (): IUiSchema => {
  return {
    stepTitle: getLocalizedText("task.information.section_header"),
    heading: getLocalizedText("task.information.section_header"),
    fields: [
      {
        fieldKey: EField.FirstName,
        uiComponent: ERentioFormField.TextField,
        title: getLocalizedText("system.firstname"),
        required: true,
        componentProps: {
          autoFocus: true,
        },
      },
      {
        fieldKey: EField.LastName,
        uiComponent: ERentioFormField.TextField,
        title: getLocalizedText("system.lastname"),
        required: true,
      },
      {
        fieldKey: EField.Email,
        uiComponent: ERentioFormField.Email,
        title: getLocalizedText("system.email"),
        required: true,
      },
      {
        fieldKey: EField.MobileNumber,
        title: getLocalizedText("system.mobile_number"),
        uiComponent: ERentioFormField.Phone,
        required: true,
      },
      {
        fieldKey: EField.Language,
        title: getLocalizedText("system.language"),
        uiComponent: ERentioFormField.Select,
        required: true,
        componentProps: {
          options: getMappedLanguages(),
        },
      },
      {
        fieldKey: "heading",
        uiComponent: ERentioFormField.Heading,
        componentProps: {
          title: getLocalizedText("address.full"),
        },
      },
      {
        fieldKey: EField.Address,
        uiComponent: ERentioFormField.AddressAutoComplete,
        title: getLocalizedText("system.address"),
        optional: true,
        onChange: (params, formikProps: IFormikProps<IFormikValues>) => {
          const { address, lookupAddress } = params as any;

          if (lookupAddress) {
            formikProps.setFieldValue(EField.Address, lookupAddress);
          }

          if (address) {
            formikProps.setFieldValue(EAddressField.Country, address?.country);
            formikProps.setFieldValue("countryId", address?.country);
            formikProps.setFieldValue(EAddressField.Street, address?.street);
            formikProps.setFieldValue(EAddressField.Number, address?.number);
            formikProps.setFieldValue(EAddressField.Box, address?.box);
            formikProps.setFieldValue(EAddressField.Zip, address?.zip);
            formikProps.setFieldValue(EAddressField.City, address?.city);
            formikProps.setFieldValue(EAddressField.State, address?.state);
          }
        },
      },
      ...getAddressComponentFields({
        addressFieldKey: EField.Address,
        overridedFields: {
          country: "countryId",
        },
        optional: true,
        overridedSpans: {
          [EAddressField.Street]: [12],
          [EAddressField.Number]: [12],
          [EAddressField.Box]: [12],
          [EAddressField.Zip]: [12],
          [EAddressField.City]: [12],
          [EAddressField.State]: [12],
          [EAddressField.Country]: [12],
        },
      }),
    ],
  };
};
